import React from 'react';
import Paragraph from '../typography/paragraph/paragraph.component';
import ParagraphProps from '../typography/paragraph/paragraph.props';
import {
  TypographyFontStyles,
  TypographySizes,
} from '../typography/base-text/constants';
import {ButtonSizes} from './constants';
import {Button as ButtonMUI, ButtonProps} from '@mui/material';

interface ButtonPropsOwn extends Omit<ButtonProps, 'size'> {
  textProps: ParagraphProps;
  size?: ButtonSizes;
}

const Button = ({onClick, textProps, size = ButtonSizes.M}: ButtonPropsOwn) => {
  return (
    <ButtonMUI
      onClick={onClick}
      style={{
        paddingTop: 1,
        borderRadius: 12,
        borderWidth: 1,
        borderStyle: 'solid',
        background: '#3e3e3e',
        padding: 12,
        margin: 24,
      }}>
      <Paragraph
        {...textProps}
        size={size as unknown as TypographySizes}
        fontStyle={TypographyFontStyles.Semibold}
      />
    </ButtonMUI>
  );
};

export default Button;
